import styled from "styled-components/macro";

export const SearchIcon = styled.svg``;

export const SearchButton = styled.button({
  padding: "0",
  margin: "0",
  border: "none",
  background: "transparent !important",
  position: "relative",
  right: "2rem",
  cursor: "pointer",
});

export const SearchInput = styled.input({});

export default styled.div({
  display: "flex",
  alignItems: "baseline",
});
